var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Timeline"}},[_c('Category',{staticClass:"mb-3"}),_c('Event',{staticClass:"mb-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }